import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://rwkkuxnpyrvvfcxmjxdu.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJ3a2t1eG5weXJ2dmZjeG1qeGR1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTE2MDM4NTMsImV4cCI6MjA2NzE3OTg1M30.ZByi2asznihGOTyCNDa5EwtrY_3-koDQc2ubZevFtG0'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
